// Inline stroke icons for the booth (24×24, currentColor). Paths follow the
// approved booth-v2 artboards; no emoji icons.

const P: Record<string, string> = {
  back: '<path d="M15 5l-7 7 7 7"/>',
  close: '<path d="M6 6l12 12M18 6 6 18"/>',
  mic: '<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21"/>',
  micOff: '<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M4 4l16 16"/>',
  flip: '<path d="M20 8h-4l-1.5-2h-5L8 8H4v11h16V8Z"/><path d="M9.5 13.5a2.5 2.5 0 0 1 4.6-1.4M14.5 13.5a2.5 2.5 0 0 1-4.6 1.4"/>',
  sparkle: '<path d="m12 3 1.8 4.4L18 9.2l-4.2 1.8L12 15.4l-1.8-4.4L6 9.2l4.2-1.8L12 3Z"/><path d="M19 15l.8 1.9 1.9.8-1.9.8L19 20.4l-.8-1.9-1.9-.8 1.9-.8L19 15Z"/>',
  invite: '<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c.6-3.6 3.3-5.5 6.5-5.5s5.9 1.9 6.5 5.5M19 8v6M16 11h6"/>',
  check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
  photos: '<rect x="3" y="5" width="18" height="14" rx="3"/><circle cx="9" cy="10" r="1.8"/><path d="M21 16l-5-5-8 8"/>',
  swap: '<path d="M7 7h12l-3-3M17 17H5l3 3"/>',
  upload: '<path d="M12 16V4M7 9l5-5 5 5M4 20h16"/>',
  link: '<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/>',
  home: '<path d="M4 11 12 4l8 7v9H4v-9Z"/><path d="M10 20v-5h4v5"/>',
  scene: '<path d="M3 19l6-8 4 5 3-3 5 6H3Z"/><circle cx="17" cy="7" r="2"/>',
  reset: '<path d="M4 12a8 8 0 1 0 2.4-5.7M4 4v4h4"/>',
  layers: '<path d="M12 3 3 8l9 5 9-5-9-5Z"/><path d="M3 13l9 5 9-5"/>',
  retry: '<path d="M20 12a8 8 0 1 1-2.4-5.7M20 4v4h-4"/>',
  alert: '<path d="M12 4 2.5 20h19L12 4Z"/><path d="M12 10v4M12 17.2v.1"/>',
  camOff: '<path d="M3 3l18 18M7 7H4v11h13M9.5 5h5L16 7h4v10"/>',
  // layout templates (two people, mirror view)
  side: '<circle cx="7.5" cy="6" r="2.5"/><circle cx="16.5" cy="6" r="2.5"/><path d="M3.5 20v-4a4 4 0 0 1 8 0v4M12.5 20v-4a4 4 0 0 1 8 0v4"/>',
  heads: '<circle cx="9.5" cy="7" r="3"/><circle cx="14.5" cy="7.5" r="3"/><path d="M3.5 20v-3.5a4.5 4.5 0 0 1 7-3.7M20.5 20v-3.5a4.5 4.5 0 0 0-7-3.7"/>',
  shoulder: '<circle cx="7.5" cy="6" r="2.5"/><circle cx="16.5" cy="6" r="2.5"/><path d="M3.5 20v-4a4 4 0 0 1 8 0v4M12.5 20v-4a4 4 0 0 1 8 0v4"/><path d="M9.5 12.5c2.5-1.6 5.2-1.8 8.2-.6"/>',
};

export type IconName = keyof typeof P;

export function icon(name: IconName, size = 22, stroke = 1.9): SVGSVGElement {
  const t = document.createElement('template');
  t.innerHTML = `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" ` +
    `stroke-width="${stroke}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${P[name]}</svg>`;
  return t.content.firstElementChild as SVGSVGElement;
}
